var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Restrict Temp Inscan on Hub InScan Manifest InScan/Restrict Manual Entry")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.hublist,
      "name": "HubName",
      "id": "HubName",
      "placeholder": "Select Hub Name",
      "label": "text",
      "track-by": "value"
    },
    on: {
      "select": _vm.setSelectedHub
    },
    model: {
      value: (_vm.hubnameArr),
      callback: function($$v) {
        _vm.hubnameArr = $$v
      },
      expression: "hubnameArr"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubloader))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.hubnameerror))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "creategroupfooter form-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "28px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchHub(_vm.hubid)
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    staticStyle: {
      "margin-top": "28px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetFlt
    }
  }, [_vm._v("Reset")])])])])])], 1)], 1), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Temp Inscan")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isactive),
        expression: "isactive"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isactive) ? _vm._i(_vm.isactive, data) > -1 : (_vm.isactive)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isactive,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isactive = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isactive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isactive = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(1)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict Temp Inscan Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 1)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Manual Entry")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isrestrictmanual),
        expression: "isrestrictmanual"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isrestrictmanual) ? _vm._i(_vm.isrestrictmanual, data) > -1 : (_vm.isrestrictmanual)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isrestrictmanual,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isrestrictmanual = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isrestrictmanual = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isrestrictmanual = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(2)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict Manual Entry Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 2)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("CentreScanIn New Version")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.iscentrescannew),
        expression: "iscentrescannew"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.iscentrescannew) ? _vm._i(_vm.iscentrescannew, data) > -1 : (_vm.iscentrescannew)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.iscentrescannew,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.iscentrescannew = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.iscentrescannew = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.iscentrescannew = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(3)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Centre ScanIn New Page Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 3)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Manifest InScan Check")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ismanifestscancheck),
        expression: "ismanifestscancheck"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.ismanifestscancheck) ? _vm._i(_vm.ismanifestscancheck, data) > -1 : (_vm.ismanifestscancheck)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ismanifestscancheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ismanifestscancheck = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.ismanifestscancheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ismanifestscancheck = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(4)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Manifest InScan Check Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 4)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Reprint Sticker for Direct Bags")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isrestrictreprintdirectbagsticker),
        expression: "isrestrictreprintdirectbagsticker"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isrestrictreprintdirectbagsticker) ? _vm._i(_vm.isrestrictreprintdirectbagsticker, data) > -1 : (_vm.isrestrictreprintdirectbagsticker)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isrestrictreprintdirectbagsticker,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isrestrictreprintdirectbagsticker = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isrestrictreprintdirectbagsticker = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isrestrictreprintdirectbagsticker = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(5)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Reprint Sticker for Direct Bag Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 5)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Bag Scan Out Manual Entry")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.outscanmanualrestrict),
        expression: "outscanmanualrestrict"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.outscanmanualrestrict) ? _vm._i(_vm.outscanmanualrestrict, data) > -1 : (_vm.outscanmanualrestrict)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.outscanmanualrestrict,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.outscanmanualrestrict = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.outscanmanualrestrict = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.outscanmanualrestrict = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(6)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Scan Out Restrict Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 6)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Bag Scan In Manual Entry")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inscanmanualrestrict),
        expression: "inscanmanualrestrict"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.inscanmanualrestrict) ? _vm._i(_vm.inscanmanualrestrict, data) > -1 : (_vm.inscanmanualrestrict)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.inscanmanualrestrict,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.inscanmanualrestrict = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.inscanmanualrestrict = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.inscanmanualrestrict = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(7)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Scan In Restrict Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 7)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Paper Work")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paperworkrestrict),
        expression: "paperworkrestrict"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.paperworkrestrict) ? _vm._i(_vm.paperworkrestrict, data) > -1 : (_vm.paperworkrestrict)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.paperworkrestrict,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.paperworkrestrict = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.paperworkrestrict = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.paperworkrestrict = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(8)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict Paper Work"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 8)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Allow TCPL Inscan")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tcplinscanallowed),
        expression: "tcplinscanallowed"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.tcplinscanallowed) ? _vm._i(_vm.tcplinscanallowed, data) > -1 : (_vm.tcplinscanallowed)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.tcplinscanallowed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.tcplinscanallowed = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.tcplinscanallowed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.tcplinscanallowed = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(10)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View TCPL Inscan Log"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 10)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Air Shipment on ManualInscan")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.airshipmentinscan),
        expression: "airshipmentinscan"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.airshipmentinscan) ? _vm._i(_vm.airshipmentinscan, data) > -1 : (_vm.airshipmentinscan)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.airshipmentinscan,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.airshipmentinscan = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.airshipmentinscan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.airshipmentinscan = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(11)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict AIr Shipment on Manual Log"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 11)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Manual Flyercode & Shipment ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.stickerprintingcontrolsrestrictions),
        expression: "stickerprintingcontrolsrestrictions"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.stickerprintingcontrolsrestrictions) ? _vm._i(_vm.stickerprintingcontrolsrestrictions, data) > -1 : (_vm.stickerprintingcontrolsrestrictions)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.stickerprintingcontrolsrestrictions,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.stickerprintingcontrolsrestrictions = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.stickerprintingcontrolsrestrictions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.stickerprintingcontrolsrestrictions = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(12)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Manual Flyer & Shipment Restrict log"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 12)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Linear Flow for Shipment Movement")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.islinearflowenabledshipment),
        expression: "islinearflowenabledshipment"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.islinearflowenabledshipment) ? _vm._i(_vm.islinearflowenabledshipment, data) > -1 : (_vm.islinearflowenabledshipment)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.islinearflowenabledshipment,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.islinearflowenabledshipment = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.islinearflowenabledshipment = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.islinearflowenabledshipment = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(13)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict Linear Flow for Shipments Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 13)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Linear Flow for Bag Movement")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.islinearflowenabledbag),
        expression: "islinearflowenabledbag"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.islinearflowenabledbag) ? _vm._i(_vm.islinearflowenabledbag, data) > -1 : (_vm.islinearflowenabledbag)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.islinearflowenabledbag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.islinearflowenabledbag = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.islinearflowenabledbag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.islinearflowenabledbag = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(14)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict Linear Flow for bag Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 14)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict BagOut Other Destination")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isallowotherdestinationbagout),
        expression: "isallowotherdestinationbagout"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isallowotherdestinationbagout) ? _vm._i(_vm.isallowotherdestinationbagout, data) > -1 : (_vm.isallowotherdestinationbagout)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isallowotherdestinationbagout,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isallowotherdestinationbagout = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isallowotherdestinationbagout = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isallowotherdestinationbagout = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(15)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict BagOut Other Destination logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 15)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Allow Redirect To LM Print Sticker")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isallowredirecttolmprintsticker),
        expression: "isallowredirecttolmprintsticker"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isallowredirecttolmprintsticker) ? _vm._i(_vm.isallowredirecttolmprintsticker, data) > -1 : (_vm.isallowredirecttolmprintsticker)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isallowredirecttolmprintsticker,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isallowredirecttolmprintsticker = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isallowredirecttolmprintsticker = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isallowredirecttolmprintsticker = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(16)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Redirect To LM Print RTO/ DTO Sticker Destination logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 16)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Allow Redirect To LM Print Forward Sticker")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isredirecttolmprintforwardsticker),
        expression: "isredirecttolmprintforwardsticker"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isredirecttolmprintforwardsticker) ? _vm._i(_vm.isredirecttolmprintforwardsticker, data) > -1 : (_vm.isredirecttolmprintforwardsticker)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isredirecttolmprintforwardsticker,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isredirecttolmprintforwardsticker = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isredirecttolmprintforwardsticker = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isredirecttolmprintforwardsticker = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(28)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Redirect To LM Print Forward Sticker Destination logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 28)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("overageApprovalFlag")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isallowoverageApprovalFlag),
        expression: "isallowoverageApprovalFlag"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isallowoverageApprovalFlag) ? _vm._i(_vm.isallowoverageApprovalFlag, data) > -1 : (_vm.isallowoverageApprovalFlag)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isallowoverageApprovalFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isallowoverageApprovalFlag = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isallowoverageApprovalFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isallowoverageApprovalFlag = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(17)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict BagOut Other Destination logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 17)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("shortageApprovalFlag")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isallowshortageApprovalFlag),
        expression: "isallowshortageApprovalFlag"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isallowshortageApprovalFlag) ? _vm._i(_vm.isallowshortageApprovalFlag, data) > -1 : (_vm.isallowshortageApprovalFlag)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isallowshortageApprovalFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isallowshortageApprovalFlag = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isallowshortageApprovalFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isallowshortageApprovalFlag = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(18)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict BagOut Other Destination logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 18)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Disable Bin Scan on SortIt V2 App")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.enablebinscanflag),
        expression: "enablebinscanflag"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.enablebinscanflag) ? _vm._i(_vm.enablebinscanflag, data) > -1 : (_vm.enablebinscanflag)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.enablebinscanflag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.enablebinscanflag = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.enablebinscanflag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.enablebinscanflag = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(19)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict Bin Scan On Sort It V2 App Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 19)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Vehicle Seal Scan In Manual Entry (Canvas Bag In-Scan)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isrestrictvehiclesealmanualinscan),
        expression: "isrestrictvehiclesealmanualinscan"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isrestrictvehiclesealmanualinscan) ? _vm._i(_vm.isrestrictvehiclesealmanualinscan, data) > -1 : (_vm.isrestrictvehiclesealmanualinscan)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isrestrictvehiclesealmanualinscan,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isrestrictvehiclesealmanualinscan = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isrestrictvehiclesealmanualinscan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isrestrictvehiclesealmanualinscan = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(20)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict Vehicle Seal InScan Manual Entry logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 20)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Restrict Vehicle Seal Scan Out Manual Entry (N/W Connection Schedule)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isrestrictvehiclesealmanualoutscan),
        expression: "isrestrictvehiclesealmanualoutscan"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isrestrictvehiclesealmanualoutscan) ? _vm._i(_vm.isrestrictvehiclesealmanualoutscan, data) > -1 : (_vm.isrestrictvehiclesealmanualoutscan)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isrestrictvehiclesealmanualoutscan,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isrestrictvehiclesealmanualoutscan = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isrestrictvehiclesealmanualoutscan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isrestrictvehiclesealmanualoutscan = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(21)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict Vehicle Seal Scan Out Manual Entry logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 21)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("mandateCompleteInboundFlag")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ismandatecompleteinboundflag),
        expression: "ismandatecompleteinboundflag"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.ismandatecompleteinboundflag) ? _vm._i(_vm.ismandatecompleteinboundflag, data) > -1 : (_vm.ismandatecompleteinboundflag)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ismandatecompleteinboundflag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ismandatecompleteinboundflag = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.ismandatecompleteinboundflag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ismandatecompleteinboundflag = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(22)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Restrict Complete Inbound Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 22)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("isholdseal")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isholdseal),
        expression: "isholdseal"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.isholdseal) ? _vm._i(_vm.isholdseal, data) > -1 : (_vm.isholdseal)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isholdseal,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isholdseal = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isholdseal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isholdseal = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(31)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Hold Seal Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 31)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Allow Priority Seal Validation for Bags")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.enablepoonlyforpriorityseal),
        expression: "enablepoonlyforpriorityseal"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.enablepoonlyforpriorityseal) ? _vm._i(_vm.enablepoonlyforpriorityseal, data) > -1 : (_vm.enablepoonlyforpriorityseal)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.enablepoonlyforpriorityseal,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.enablepoonlyforpriorityseal = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.enablepoonlyforpriorityseal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.enablepoonlyforpriorityseal = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(23)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Allow Priority Seal Validation for Bags"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 23)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("B2B Load Plan")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isb2bloadplanenabled),
        expression: "isb2bloadplanenabled"
      }],
      attrs: {
        "type": "checkbox",
        "true-value": true,
        "false-value": false
      },
      domProps: {
        "checked": Array.isArray(_vm.isb2bloadplanenabled) ? _vm._i(_vm.isb2bloadplanenabled, null) > -1 : (_vm.isb2bloadplanenabled)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isb2bloadplanenabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isb2bloadplanenabled = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isb2bloadplanenabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isb2bloadplanenabled = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(24)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View B2B Load Plan Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 24)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Recon QC Enabled")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isreconqcenabled),
        expression: "isreconqcenabled"
      }],
      attrs: {
        "type": "checkbox",
        "true-value": true,
        "false-value": false
      },
      domProps: {
        "checked": Array.isArray(_vm.isreconqcenabled) ? _vm._i(_vm.isreconqcenabled, null) > -1 : (_vm.isreconqcenabled)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isreconqcenabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isreconqcenabled = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isreconqcenabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isreconqcenabled = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(25)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Recon QC Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 25)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Weighing Infra Available")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isweighinginfraavailable),
        expression: "isweighinginfraavailable"
      }],
      attrs: {
        "type": "checkbox",
        "true-value": true,
        "false-value": false
      },
      domProps: {
        "checked": Array.isArray(_vm.isweighinginfraavailable) ? _vm._i(_vm.isweighinginfraavailable, null) > -1 : (_vm.isweighinginfraavailable)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isweighinginfraavailable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isweighinginfraavailable = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isweighinginfraavailable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isweighinginfraavailable = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(27)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Weighing Infra Available Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 27)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData),
      expression: "tableData"
    }]
  }, [_c('legend', [_vm._v("Mandatory Weighing")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted",
    staticStyle: {
      "font-size": "0.9em",
      "margin-bottom": "0.75rem"
    }
  }, [_vm._v("\n            Hub-level Enable / Warning / Disable is configured here.\n            "), _c('router-link', {
    attrs: {
      "to": "/MandatoryWeighingEventConfig"
    }
  }, [_vm._v("Edit global event rules")]), _vm._v("\n            (Default vs Exception actions per scan event).\n          ")], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hubdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname) + " (" + _vm._s(data.hubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ismandatoryweighingflag),
        expression: "ismandatoryweighingflag"
      }],
      staticClass: "form-control",
      staticStyle: {
        "display": "inline-block",
        "width": "auto"
      },
      attrs: {
        "disabled": _vm.isMandatoryWeighingDropdownDisabled,
        "title": _vm.isMandatoryWeighingDropdownDisabled ? 'Enable Weighing Infra Available to change this flag' : ''
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.ismandatoryweighingflag = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "default"
      }
    }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "disable"
      }
    }, [_vm._v("Disable")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "exception"
      }
    }, [_vm._v("Exception")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.allocateHub(26)
        }
      }
    }, [_vm._v("UPDATE")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Mandatory Weighing Logs"
      },
      on: {
        "click": function($event) {
          return _vm.getLogRestrictTempHubInscan(data, 26)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.hubdetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')])])], 1)])]), _vm._v(" "), (_vm.showModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Connections List"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.popUpname))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "150px",
      "margin-top": "00px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.hubinscanlogs), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.date) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationWindow",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.insertHubDetails = false
      }
    },
    model: {
      value: (_vm.insertHubDetails),
      callback: function($$v) {
        _vm.insertHubDetails = $$v
      },
      expression: "insertHubDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinsertHubDetails
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Record not present, Do you want to insert new records ?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.insertHub, function($event) {
        _vm.insertHubDetails = false
      }]
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinsertHubDetails
    }
  }, [_vm._v("NO")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d80431ee","hasScoped":true}!./src/views/components/RestrictTempInscanOnHub/RestrictTempInscanOnHub.html
// module id = 1737
// module chunks = 2